export class MathUtils
{
	static clamp(x:number, minVal:number, maxVal:number)
	{
		return x < minVal ? minVal : x > maxVal ? maxVal : x;
	}
}